// JavaScript version of usePeerMediaIssues.ts
import { useEffect, useRef, useState } from 'react';
import { MediaIssueInspector } from './mediaIssues';

/**
 * @param {{
 *  peerIds: string[],
 *  localPeerId: string,
 *  pollIntervalMs?: number,
 *  getPeerStatSample: (peerId: string, isLocal: boolean) => Promise<{
 *    audioOutboundPackets?: number,
 *    audioInboundPackets?: number,
 *    videoOutboundPackets?: number,
 *    videoInboundPackets?: number,
 *    audioRemoteRtpId?: string | null,
 *    videoRemoteRtpId?: string | null,
 *  } | null>
 * }} params
 */
export function usePeerMediaIssues({ peerIds, localPeerId, pollIntervalMs = 2000, getPeerStatSample }) {
  const inspectorRef = useRef(new MediaIssueInspector());
  const [issues, setIssues] = useState(() => inspectorRef.current.all());

  useEffect(() => {
    let cancelled = false;

    async function poll() {
      for (const pid of peerIds) {
        const isLocal = pid === localPeerId;
        try {
          const sample = await getPeerStatSample(pid, isLocal);
          if (sample) {
            inspectorRef.current.update(pid, isLocal, sample);
          }
        } catch {
          // ignore individual errors
        }
      }
      if (!cancelled) {
        setIssues(inspectorRef.current.all());
        setTimeout(poll, pollIntervalMs);
      }
    }
    poll();
    return () => { cancelled = true; };
  }, [peerIds, localPeerId, pollIntervalMs, getPeerStatSample]);

  return issues;
}
